"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const pages_1 = require("../../../pages");
const Aside = ({ asideMobileActive }) => {
    const Outlet = (0, pages_1.useNamedOutlet)("menu");
    return (react_1.default.createElement("aside", { className: (0, classnames_1.default)("aside", asideMobileActive && "has-aside") },
        react_1.default.createElement(Outlet, null)));
};
exports.default = Aside;
